import pluralize from "pluralize";

// What the warehouse counted and measured on receipt, as opposed to the
// customer-declared packing list.
export interface MeasuredTotals {
  cartons: number | null;
  cbm: number | null;
  at: Date | null;
}

interface MeasurableShipment {
  measuredCartons: number | null;
  measuredCbm: number | null;
  measuredAt: Date | null;
}

export function toMeasuredTotals(
  shipment: MeasurableShipment,
): MeasuredTotals | null {
  if (shipment.measuredCartons == null && shipment.measuredCbm == null) {
    return null;
  }
  return {
    cartons: shipment.measuredCartons,
    cbm: shipment.measuredCbm,
    at: shipment.measuredAt,
  };
}

/** "12 cartons · 3.4 m³", or "" when neither figure was recorded. */
export function formatMeasured(
  cartons: number | null,
  cbm: number | null,
): string {
  const parts: string[] = [];
  if (cartons != null) {
    parts.push(`${cartons} ${pluralize("carton", cartons)}`);
  }
  if (cbm != null) {
    // Trim the stored float back to what the warehouse actually typed.
    parts.push(`${Number(cbm.toFixed(3))} m³`);
  }
  return parts.join(" · ");
}
